import { useTranslations } from '@npco/common-utils-translations'
import { BodySmall, Box, COLOR } from '@npco/zeller-design-system'

import { ReactComponent as ArrowBadge } from 'assets/svg/setup-flow/arrow-card-details.svg'

import { setupFlowDebitCardDetailsTranslations } from '../DebitCardDetails.i18n'

interface DebitCardDetailsCopyInfoDesktopProps {
  isDetailsVisible: boolean
}
export const DebitCardDetailsCopyInfoDesktop = ({
  isDetailsVisible,
}: DebitCardDetailsCopyInfoDesktopProps) => {
  const t = useTranslations(setupFlowDebitCardDetailsTranslations)

  return (
    <Box position="absolute" left="250px" bottom="70px">
      <ArrowBadge />
      <Box
        maxWidth="210px"
        position="absolute"
        top="14px"
        right="calc(-100% - 60px)"
        color={COLOR.GREY_550}
      >
        <Box as={BodySmall} m="0">
          {t(isDetailsVisible ? 'hideMessageDesktop' : 'showMessageDesktop')}
        </Box>
      </Box>
    </Box>
  )
}
